import type { PostSource } from '../types';

import { href } from 'react-router';

import { type PharmacyRoute, ROUTES } from '~shared/routes';

const SHARE_SOURCE_ROUTES: Partial<Record<string, PharmacyRoute>> = {
  ARTICLE: ROUTES.content.blog,
  PHARMACIST_WORD: ROUTES.content.pharmacistWord,
  PROMOTION_CNC: ROUTES.promotions.promotionsCnc,
  PROMOTION_SNC: ROUTES.promotions.promotionsSnC,
};

export function routeForSource(
  source: PostSource,
  pharmacyId: string
): string | undefined {
  const route = SHARE_SOURCE_ROUTES[source.type];

  return route ? href(route, { pharmacyId }) : undefined;
}
